export type VideoStatus = {
  label: string;
  value: string;
};

export enum VideoRate {
  'FD' = '流畅',
  'SD' = '高清',
  'HD' = '超清',
  'OD' = '原画',
  '2K' = '2K',
  '4K' = '4K',
  'AUTO' = '智能'
}

export type VideoRateKey = keyof typeof VideoRate;

export interface PlayItem {
  definition: VideoRateKey;
  width: number;
  height: number;
  size: number;
  playUrl: string;
  format: string;
}

export interface Result {
  vodVideoPlayInfo: {
    id: string;
    status: string;
    title: string;
    description: string;
    coverUrl: string;
    duration: number;
    playList: PlayItem[];
  };
  vodOptions: {
    videoStatuses: VideoStatus[];
  };
}

type ResultWithObjPlayList = {
  vodVideoPlayInfo: {
    id: string;
    status: string;
    title: string;
    description: string;
    coverUrl: string;
    duration: number;
    playList: Record<VideoRateKey, Omit<PlayItem, 'definition'> | undefined>;
  };
  vodOptions: {
    videoStatuses: VideoStatus[];
  };
};
